<template>
	<v-container fluid>
		<v-row class="pa-3">
			<v-btn @click="addClick" class="ml-0" color="primary">
				<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{$t('buttons.add')}}
			</v-btn>
		</v-row>
		<v-row>
			<v-col lg="12" cols="12">
				<v-card outlined flat>
					<v-card-text>
						<DataTable
							:excel="true"
							:headers="buildingsTable.headers"
							:items="buildingsTable.items"
							:total="buildingsTable.total"
							@excel="excelExport"
							@reload="reloadData"
						>
							<template #row="props">
								<tr :class="{'cursor-pointer': true}" @contextmenu.prevent="editClick(props.item.id, true)">
									<td @click="editClick(props.item.id, false)">{{ props.item.code }}</td>
									<td @click="editClick(props.item.id, false)">{{ props.item.street_and_no }}</td>
									<td @click="editClick(props.item.id, false)">{{ props.item.postal_code }}</td>
									<td @click="editClick(props.item.id, false)">{{ props.item.city }}</td>
									<td @click="editClick(props.item.id, false)">{{ props.item.country }}</td>
									<td @click="editClick(props.item.id, false)">
										<v-icon small v-if="props.item.active">fa-check</v-icon>
									</td>
									<td>
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn @click="editClick(props.item.id, true)" icon v-bind="attrs" v-on="on">
												<v-icon small>fa-external-link-alt</v-icon>
											</v-btn>
											</template>
											<span>{{$t('tooltips.openInNewTab')}}</span>
										</v-tooltip>
									</td>
								</tr>
							</template>
						</DataTable>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import DataTable from "./trinkets/DataTable";

export default {
	name: "Buildings",
	components: {DataTable},
	data: function () {
		return {
			buildingsTable: {
				headers: [
					{text: this.$t('fields.code'), value: 'code', type: 'string', searchable: 'hidden'},
					{text: this.$t('fields.streetAndNo'), value: 'street_and_no', type: 'string', searchable: 'hidden'},
					{text: this.$t('fields.postalCode'), value: 'postal_code', type: 'string', searchable: 'hidden'},
					{text: this.$t('fields.city'), value: 'city', type: 'string', searchable: 'hidden'},
					{text: this.$t('fields.country'), value: 'country', type: 'string', searchable: 'hidden'},
					{text: this.$t('fields.active'), value: 'active', type: 'boolean_yes', width: "100px", searchable: 'hidden'},
					{text: '', value: 'actions', type: '', sortable: false, align: "right", width: "100px", searchable: false}
				],
				items: [],
				total: 0,
				lastRequest: null
			},

		}
	},
	methods: {
		addClick() {
			this.$router.push('/buildings/0')
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/buildings/' + id)
			} else {
				let routeData = this.$router.resolve('/buildings/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		reloadData(request) {
			this.lastRequest = request;
			let vm = this;
			this.$APICall('get', 'buildings', request, (data, success) => {
				if (success) {
					vm.buildingsTable.items = data.items;
					vm.buildingsTable.total = data.total;
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			}, false);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
			excelRequest.pagination.rowsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall('get', 'buildings', excelRequest, (data, success) => {
				if (success) {
					vm.$APICall('post', 'excel/buildings', data.items, (data, success) => {
						window.open(data.link);
					});
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			}, false);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{text: this.$t('modules.buildings'), href: '/#/buildings', disabled: true}
		]);
	}
}
</script>

<style scoped>

</style>
